import { TaskStatus } from 'app/constants/taskStatus'

export const getTaskStatus = (status): TaskStatus => {
  let taskStatus = TaskStatus.New

  switch (status) {
    case 1:
      taskStatus = TaskStatus.Pending
      break
    case 2:
      taskStatus = TaskStatus.Importing
      break
    case 3:
      taskStatus = TaskStatus.Completed
      break
    case 4:
      taskStatus = TaskStatus.Error
      break
  }

  return taskStatus
}
